var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevvTshirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7903 27.5636L21.879 11.4694L22.2807 15.7495L27.1399 13.9639C27.1399 13.9639 26.0228 7.99263 24.3757 6.29932C22.7285 4.60602 18.6272 3 18.6272 3C18.6272 3 17.4655 6.29932 14.5678 6.16448H14.5721C11.6744 6.29932 10.5148 3.00284 10.5148 3.00284C10.5148 3.00284 6.41353 4.60744 4.76422 6.29932C3.11491 7.99121 2 13.9696 2 13.9696L6.86134 15.753L7.26302 11.4729L7.35173 27.5672L21.7903 27.5636Z",
    stroke: "#61A578",
    strokeWidth: 0.993559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevvTshirt);
export default __webpack_public_path__ + "static/media/revv_tshirt.706fecee8a97ab5050ff81a320ecb3e2.svg";
export { ForwardRef as ReactComponent };